import { FC, lazy } from 'react';
import { graphql, useFragment } from 'react-relay';

// components
import { ClientSuspense } from 'dibs-elements/exports/ClientSuspense';
import { SharedRespAuctionMosaicLoading } from '../../shared/SharedRespAuctionMosaicCarousel/SharedRespAuctionMosaicLoading';

// types
import { SbRespPersonalizedAuctionsModuleLazy_user$key as User } from './__generated__/SbRespPersonalizedAuctionsModuleLazy_user.graphql';

export const SbRespPersonalizedAuctionsModuleLazyComponent = lazy(
    () =>
        import(
            /* webpackChunkName: "SbRespPersonalizedAuctionsModule" */ './SbRespPersonalizedAuctionsModule'
        )
);

type Props = {
    user: User;
};

const userFragment = graphql`
    fragment SbRespPersonalizedAuctionsModuleLazy_user on User {
        ...SbRespPersonalizedAuctionsModule_user
    }
`;

export const SbRespPersonalizedAuctionsModuleLazy: FC<Props> = ({ user: userRef }) => {
    const user = useFragment(userFragment, userRef);
    return (
        <ClientSuspense fallback={<SharedRespAuctionMosaicLoading />}>
            <SbRespPersonalizedAuctionsModuleLazyComponent user={user} />
        </ClientSuspense>
    );
};
